import Blue from "~/core";
import Swiper from "swiper";
import {
  A11y,
  Keyboard,
  Autoplay,
} from "swiper/modules";

Swiper.use([A11y, Keyboard, Autoplay]);

new Blue({
  name: "Sitemap Slider",
  selector: ".sitemap-anchors",
  setup(sitemapAnchors) {
    const sections = document.querySelectorAll('.sitemap-area');
    const slides = sitemapAnchors.querySelectorAll('.swiper-slide');

    const swiper = new Swiper(sitemapAnchors, {
      keyboard: true,
      a11y: true,
      freeMode: true,
      spaceBetween: 10,
      grabCursor: true,
      slidesPerView: "auto"
    });


    const idToIndexMap = {};
    let ticking = false;

    slides.forEach((slide, index) => {
      const href = slide.getAttribute('href');
      if (href && href.startsWith('#')) {
        const id = href.slice(1);
        idToIndexMap[id] = index;
      }
    });
    
    function getHeaderHeight() {
      const headerHeight = document.documentElement.style.getPropertyValue('--header-height');
      return (parseInt(headerHeight) || 0) + swiper.el.offsetHeight;
    }
    
    function findClosestSection() {
      const headerHeight = getHeaderHeight();
      let closestId = null;
      let closestOffset = Infinity;
    
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const topOffset = rect.top - headerHeight;
    
        if (topOffset <= 0 && Math.abs(topOffset) < closestOffset) {
          const id = section.querySelector('h2')?.id;
          if (id) {
            closestOffset = Math.abs(topOffset);
            closestId = id;
          }
        }
      });
    
      if (closestId && closestId in idToIndexMap) {
        const index = idToIndexMap[closestId];
        if (swiper.activeIndex !== index) {
          activateSlide(index);
        }
      }
    }
    
    function activateSlide(index) {
      swiper.slideTo(index);
    
      swiper.slides.forEach((slide, i) => {
        if (i === index)
          slide.classList.add('sitemap-anchors__active');
        else
          slide.classList.remove('sitemap-anchors__active');
      });
    }
    

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          findClosestSection(); 
          ticking = false;
        });
        ticking = true;
      }
    });
  }
});
